import CAxios from "../../../Utils/CAxios";

export const toGetRelances = async (page, perPage, options) => {
  try {
    const { data } = await CAxios.get(`/api/relances`, {
      params: {
        page,
        perPage,
        dateFrom: options.dateFrom,
        dateTo: options.dateTo,
        statut: options.statut,
        ref: options.ref || undefined,
      },
    });
    return data.success || { res: [], total: 0 };
  } catch (e) {
    return { res: [], total: 0 };
  }
};

export const toGetRelanceDetails = async (id) => {
  try {
    const { data } = await CAxios.get(`/api/relances/${id}`);
    return data.success && data.success.relance ? data.success.relance : null;
  } catch (e) {
    return null;
  }
};

export const toGetRelancesStats = async (days = 30) => {
  try {
    const { data } = await CAxios.get(`/api/relances/stats`, {
      params: { days },
    });
    return data.success || { stats: [], totals: { envoye: 0, echec: 0, nb: 0, montant: "0" } };
  } catch (e) {
    return { stats: [], totals: { envoye: 0, echec: 0, nb: 0, montant: "0" } };
  }
};